export default "__VITE_ASSET__WbquOI0b__"